import React, { useRef, useMemo, useEffect, useState, Fragment } from "react";
import {
  Grid,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
  CircularProgress,
  Paper,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import Pagination from "components/Pagination";
import Colors from "assets/Style/Colors";
import { makeStyles } from "@mui/styles";
import { FontFamily } from "assets";
import { PrimaryButton } from "components/Buttons";
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import InputField from "components/Input";
import { Upload } from "@mui/icons-material";
import UploadFile from "components/UploadFile";
import SelectField from "components/Select";
import VendorServices from "services/Vendor";
import CloseIcon from "@mui/icons-material/Close";
import { useAuth } from "context/UseContext";
import DropdownMenu from "components/DropDown";
import AgentBotServices from "services/bot";

// *For Table Style
const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    padding: "15px",
    textAlign: "center",
    whiteSpace: "nowrap",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    textWrap: "nowrap",
    padding: "5px !important",
    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

const useStyles = makeStyles({
  loaderWrap: {
    display: "flex",
    height: 100,
    "& svg": {
      width: "40px !important",
      height: "40px !important",
    },
  },
});

function UploadVendorInvoice() {
  const [selectedManifest, setselectedManifest] = useState(null);
  const [manifestOptions, setmanifestOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  const navigate = useNavigate();
  const [editOpen, setEditOpen] = useState(false);
  const [selectedItem, setSelecteditem] = useState(null);
  const [uploadInvoiceData, setUploadInvoiceData] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const handleMenuToggle = (menuId, isOpen) => {
    setActiveMenu(isOpen ? menuId : null);
  };

  const handleEditOpen = (record) => {
    setSelecteditem(record.id);
    setEditOpen(true);

    let defaultPermission = "false";

    if (record?.module_type === "shipping_towing") {
      defaultPermission = record?.shipping_status === true ? "true" : "false";
    } else {
      defaultPermission = record?.status === true ? "true" : "false";
    }

    setSelectedPermission(defaultPermission);
  };

  const handleEditClose = () => {
    setEditOpen(false);
    setSelecteditem(null);
  };

  const contentRef = useRef(null);
  const { user } = useAuth();

  const {
    register,
    handleSubmit,
    getValues: getValues1,
    setValue,
    formState: { errors },
    watch,
  } = useForm();

  const tableHead = [
    "Sr.No",
    "Invoice Type",
    "Invoice No",
    "Vendor Name",
    "Upload Date",
    "Uploaded By",
    "Allow Bot",
    "Action",
  ];

  const module_types = [
    { id: "shipping_towing", name: "Shipping/Towing" },
    { id: "clearance", name: "Clearance" },
  ];

  const [loader, setLoader] = useState(false);
  const [confirmationDialog, setConfirmationDialog] = useState(false);

  // *For Pagination
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  // *For Filters
  const [filters, setFilters] = useState({});
  const [selectedValue, setSelectedValue] = useState("option1");

  const handleRadioChange = (value) => setSelectedValue(value);

  const [auctionHouses, setAuctionHouses] = useState();
  const [selectedAuctionHouses, setSelectedAuctionHouses] = useState("");

  const [openWhatsAppModal, setOpenWhatsAppModal] = useState(false);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteInvoiceId, setSelectedDeleteInvoiceId] = useState(0);

  const [permissions, setPermissions] = useState();
  const [invoiceDatas, setInvoiceDatas] = useState([]);
  const [searchTerm, setSearchTerm] = useState();

  // Upload dialog state
  const [isUploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState(""); // <<< added
  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [selectedInvoiceType, setSelectedInvoiceType] = useState(null);

  const ALLOWED_PDF = ["application/pdf"];
  const ALLOWED_EXCEL = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];
  const acceptAttr = useMemo(() => {
    return ".pdf,.xls,.xlsx";
  }, []);

  const validateFile = (f) => {
    if (!f) return { ok: false, msg: "Please attach a file" };

    const type = f.type;
    const name = f.name?.toLowerCase() || "";
    const ext = name.split(".").pop();

    const isPdfByMime = ALLOWED_PDF.includes(type);
    const isExcelByMime = ALLOWED_EXCEL.includes(type);
    const isPdfByExt = ext === "pdf";
    const isExcelByExt = ["xls", "xlsx"].includes(ext);

    if (isPdfByMime || isExcelByMime || isPdfByExt || isExcelByExt) {
      return { ok: true };
    }

    return {
      ok: false,
      msg: "Allowed file types: PDF, XLS, XLSX.",
    };
  };

  // If user changes vendor/type after selecting a file, revalidate and possibly clear it  // <<< added
  useEffect(() => {
    if (!file) return;

    const { ok, msg } = validateFile(file);

    if (!ok) {
      setFile(null);
      setUploadedFileName("");
      setFileError(msg);
    } else {
      setFileError("");
    }
  }, [file]);

  // ---------- Data fetching ---------- //
  const getInvoiceData = async (page, limit, filter) => {
    setLoader(true);
    try {
      const Page = page || currentPage;
      const Limit = limit || pageLimit;
      const Filter = { ...filters, ...filter };

      setCurrentPage(Page);
      setPageLimit(Limit);
      setFilters(Filter);

      let params = {
        module_type: "shipping_towing, clearance",
        page: Page,
        limit: Limit,
        user_id: user?.id,
        ...Filter,
      };

      const { data } = await VendorServices.getUploadedVendorInvoices(params);

      setUploadInvoiceData(data?.rows);
      setTotalCount(data?.count);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };

  const handleFilter = async (data) => {
    setLoader(true);
    if (isSearching) return;

    setIsSearching(true);
    try {
      await getInvoiceData(1, "", data);
    } catch (err) {
      console.error("Search failed:", err);
    } finally {
      setIsSearching(false);
      setLoader(false);
    }
  };

  const uploadInvoice = async () => {
    if (!selectedInvoiceType?.id) return ErrorToaster("Select invoice type");
    if (!selectedVendor?.id) return ErrorToaster("Select vendor");
    if (!file) return ErrorToaster("Attach a file");

    // Final guard — validate before submit  // <<< added
    const { ok, msg } = validateFile(file);
    if (!ok) {
      setFileError(msg);
      return ErrorToaster(msg);
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("moduleType", selectedInvoiceType?.id);
      formData.append("vendor_id", selectedVendor?.id);
      formData.append("vendor_name", selectedVendor?.name);
      formData.append("upload_by_id", user?.id);
      formData.append("file", file, file.name);

      const { message } = await VendorServices.uploadVendorInvoice(formData);

      SuccessToaster(message);
      setUploadDialogOpen(false);

      setSelectedInvoiceType(null);
      setSelectedVendor(null);
      setFile(null);
      setUploadedFileName("");
      setFileError("");

      getInvoiceData();
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenUploadDialog = () => {
    setUploadDialogOpen(true);
  };

  useEffect(() => {
    getInvoiceData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseUploadDialog = () => {
    setUploadDialogOpen(false);
    setFile(null);
    setUploadedFileName("");
    setFileError(""); // <<< added
  };

  const downloadAllAttachments = async (documentLinks) => {
    if (!documentLinks || documentLinks.trim() === "") {
      ErrorToaster("No attachments available.");
      return;
    }

    const filePath = documentLinks.trim();
    const fileUrl = `${filePath}`;
    const fileExtension = filePath.split(".").pop();

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `attachment.${fileExtension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
      SuccessToaster("Downloading attachment...");
    } catch (error) {
      console.error("Download failed", error);
      ErrorToaster("Failed to download attachment.");
    }
  };

  const getVendorDropdown = async () => {
    try {
      const { data } = await VendorServices.getVendorDropdown();
      setVendors(data?.vendors);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    getVendorDropdown();
  }, []);

  const [selectedPermission, setSelectedPermission] = useState("false");

  const handleFinalSubmit = () => {
    const allow = selectedPermission === "true";
    handleAllow(allow);
  };

  const handleAllow = async (allow) => {
    try {
      const payload = { id: selectedItem, allow };
      const { data, message } =
        await AgentBotServices.agentPermissionUpdate(payload);

      handleEditClose();
      getInvoiceData();
      SuccessToaster(message);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const getCleanUrl = (url) => {
    if (!url) return "";

    const index = url.indexOf("/invoices");
    if (index === -1) return url; // if "invoices" not found, return original

    return url.substring(index + 1); // remove leading slash
  };

  return (
    <>
      <Dialog
        open={isUploadDialogOpen}
        onClose={handleCloseUploadDialog}
        PaperProps={{ sx: { p: 2, width: "500px", borderRadius: "14px" } }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>Upload Vendor Invoice</span>
          <IconButton onClick={handleCloseUploadDialog} sx={{ padding: 0 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <SelectField
            size="small"
            label={"Invoice Type"}
            options={module_types}
            selected={selectedInvoiceType}
            onSelect={(value) => setSelectedInvoiceType(value)}
            error={errors?.invpiceType?.message}
            register={register("invpiceType")}
          />
          <SelectField
            size="small"
            label={"Vendor Name"}
            options={vendors}
            selected={selectedVendor}
            onSelect={(value) => setSelectedVendor(value)}
            error={errors?.vendorName?.message}
            register={register("vendorName")}
          />
          <Typography variant="body1" sx={{ mb: 1, mt: 2 }}>
            Attach File
          </Typography>
          <UploadFile
            custom={true}
            vendor={true}
            accept={acceptAttr}
            style={{
              backgroundColor: "#e7efeb",
              width: "100%",
              height: "40px",
              display: "flex",
              justifyContent: "space-between",
              padding: "30px",
              border: "1px dashed #aeb1b0",
              borderRadius: "10px",
            }}
            error={fileError || errors?.scanned?.message}
            register={register("scanned", {
              onChange: (e) => {
                const selectedFile = e.target.files?.[0];
                if (!selectedFile) {
                  setFile(null);
                  setUploadedFileName("");
                  setFileError("");
                  return;
                }

                const { ok, msg } = validateFile(selectedFile);
                if (!ok) {
                  // reject + clear
                  setFile(null);
                  setUploadedFileName("");
                  setFileError(msg);
                  e.target.value = ""; // clear file input
                  return;
                }

                setFile(selectedFile);
                setUploadedFileName(selectedFile.name);
                setFileError("");
              },
            })}
          />
          {/* Allowed types hint */} {/* <<< added */}
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: "block", mt: 1 }}
          >
            {"Allowed: PDF or Excel (.xls, .xlsx)"}
          </Typography>
          {/* Filename + inline error */} {/* <<< added */}
          {uploadedFileName && (
            <Typography variant="body2" sx={{ mt: 1.25, color: "#333" }}>
              <strong>Uploaded File: </strong>
              {uploadedFileName}
            </Typography>
          )}
          {fileError && (
            <Typography variant="body2" sx={{ mt: 0.75, color: "#d32f2f" }}>
              {fileError}
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <PrimaryButton
            title={loading ? "Uploading..." : "Upload"}
            onClick={uploadInvoice}
            disabled={loading || !file || !!fileError} // <<< added
          />
        </DialogActions>
      </Dialog>

      <Dialog
        open={editOpen}
        onClose={handleEditClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Typography
            sx={{
              fontSize: 17,
              fontFamily: FontFamily.openSans,
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            AI vendor costing agent can process this invoice?
          </Typography>
        </DialogTitle>

        <DialogContent>
          <RadioGroup
            row
            sx={{ justifyContent: "center", mt: 1 }}
            value={selectedPermission}
            onChange={(e) => setSelectedPermission(e.target.value)}
          >
            <FormControlLabel
              value="false"
              control={<Radio color="success" />}
              label="Allow"
            />
            <FormControlLabel
              value="true"
              control={<Radio color="error" />}
              label="Disallow"
            />
          </RadioGroup>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <PrimaryButton
            title="Cancel"
            type="button"
            buttonStyle={{
              minWidth: "120px",
              bgcolor: "#b0b0b0",
              "&:hover": { bgcolor: "#9a9a9a" },
            }}
            onClick={handleEditClose}
          />
          <Box component="span" sx={{ mx: 1 }} />
          <PrimaryButton
            title="Submit"
            type="button"
            buttonStyle={{
              minWidth: "120px",
              bgcolor: Colors.danger,
              "&:hover": { bgcolor: Colors.danger },
            }}
            onClick={handleFinalSubmit}
          />
        </DialogActions>
      </Dialog>

      <Box component={"form"}>
        <Box sx={{ width: "100%" }}>
          <Grid container>
            <Grid item md={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  my: 3,
                  ml: 4,
                  mr: 8,
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    color: Colors.charcoalGrey,
                    fontFamily: FontFamily.NunitoRegular,
                    textAlign: "left",
                  }}
                >
                  Upload Vendor Invoice
                </Typography>
                <Box
                  sx={{
                    textAlign: "right",
                    p: 4,
                    display: "flex",
                    gap: 2,
                  }}
                >
                  <PrimaryButton
                    title="Upload Invoice"
                    type="button"
                    style={{ backgroundColor: Colors.bluishCyan }}
                    startIcon={<Upload sx={{ color: Colors.white }} />}
                    onClick={handleOpenUploadDialog}
                  />
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={3} style={{ marginLeft: "35px" }}>
              <InputField
                size={"small"}
                label={"Search"}
                placeholder={"Search"}
                register={register("search", {
                  onChange: (e) => handleFilter({ search: e.target.value }),
                })}
              />
            </Grid>
          </Grid>
        </Box>

        <Grid container sx={{ borderRadius: "5px", m: 4, mt: 0 }}></Grid>

        <Box sx={{ m: 4, mb: 2 }}>
          {uploadInvoiceData ? (
            <Fragment>
              <Box className="pdf-show" sx={{ display: "none" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography
                    variant="h5"
                    sx={{
                      color: Colors.charcoalGrey,
                      fontFamily: FontFamily.NunitoRegular,
                      mb: 2,
                    }}
                  >
                    Export Vehicle Payments
                  </Typography>
                  <Box
                    sx={{
                      fontWeight: 400,
                      fontSize: "12px",
                      mt: 1.5,
                      color: Colors.charcoalGrey,
                    }}
                  >
                    <span>Date: &nbsp;&nbsp;</span>
                    {moment().format("MM-DD-YYYY")}
                  </Box>
                </Box>
              </Box>

              <TableContainer
                component={Paper}
                sx={{
                  boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                  borderRadius: 2,
                }}
                className="table-box"
              >
                <Table stickyHeader sx={{ minWidth: 500 }}>
                  <TableHead>
                    <TableRow>
                      {tableHead.map((item, index) => (
                        <Cell className="pdf-table" key={index}>
                          {item}
                        </Cell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {!loader ? (
                      uploadInvoiceData.length > 0 ? (
                        <Fragment>
                          {uploadInvoiceData.map((item, index) => {
                            const findModule = module_types?.find(
                              (val) => val?.id === item?.module_type,
                            );
                            return (
                              <Row
                                key={index}
                                sx={{ bgcolor: index % 2 !== 0 && "#EFF8E7" }}
                              >
                                <Cell className="pdf-table">
                                  {index + 1 ?? "-"}
                                </Cell>
                                <Cell className="pdf-table">
                                  {findModule?.name ?? "-"}
                                </Cell>
                                <Cell className="pdf-table">
                                  {item?.invoice_no ?? "-"}
                                </Cell>
                                <Cell className="pdf-table">
                                  {item?.vendor?.name ?? "-"}
                                </Cell>
                                <Cell className="pdf-table">
                                  {moment(item?.created_at).format(
                                    "DD-MM-YYYY",
                                  ) ?? "-"}
                                </Cell>
                                <Cell className="pdf-table">
                                  {item?.upload_by?.name ?? "-"}
                                </Cell>
                                <Cell className="pdf-table">
                                  {item?.module_type === "shipping_towing"
                                    ? item?.shipping_status === true
                                      ? "No"
                                      : "Yes"
                                    : item.status === true
                                      ? "No"
                                      : "Yes"}
                                </Cell>
                                <Cell className="pdf-table">
                                  {/* {item?.response_url ? (
                                    <div
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        downloadAllAttachments(
                                          item?.response_url
                                        )
                                      }
                                    >
                                      <FiDownload
                                        color={Colors.primary}
                                        size={25}
                                      />
                                    </div>
                                  ) : (
                                    <FiDownload color="gray" size={25} />
                                  )} */}
                                  <Box
                                    component={"div"}
                                    className="pdf-hide"
                                    sx={{ gap: "16px !important" }}
                                  >
                                    <DropdownMenu
                                      item={item}
                                      permissions={permissions}
                                      navigate={navigate}
                                      ErrorToaster={ErrorToaster}
                                      Colors={Colors}
                                      isOpen={activeMenu === item.id}
                                      onToggle={(isOpen) =>
                                        handleMenuToggle(item.id, isOpen)
                                      }
                                      uploadVendorInvoiceEdit={() =>
                                        handleEditOpen(item)
                                      }
                                      downloadVendorInvoice={() => {
                                        downloadAllAttachments(
                                          process.env.REACT_APP_ENV === "stg"
                                            ? item?.response_url
                                            : "https://media.galaxyshipping.com/" +
                                                getCleanUrl(item?.response_url),
                                        );
                                      }}
                                      id={item?.id}
                                    />
                                  </Box>
                                </Cell>
                              </Row>
                            );
                          })}
                        </Fragment>
                      ) : (
                        <Row>
                          <Cell
                            colSpan={tableHead?.length + 1}
                            align="center"
                            sx={{ fontWeight: 600 }}
                          >
                            No Data Found
                          </Cell>
                        </Row>
                      )
                    ) : (
                      <Row>
                        <Cell
                          colSpan={tableHead?.length + 2}
                          align="center"
                          sx={{ fontWeight: 600 }}
                        >
                          <Box className={classes.loaderWrap}>
                            <CircularProgress />
                          </Box>
                        </Cell>
                      </Row>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <Pagination
                currentPage={currentPage}
                pageSize={pageLimit}
                onPageSizeChange={(size) =>
                  getInvoiceData(1, size.target.value)
                }
                tableCount={uploadInvoiceData?.length}
                totalCount={totalCount}
                onPageChange={(page) => getInvoiceData(page, "")}
              />
            </Fragment>
          ) : (
            ""
          )}
        </Box>
      </Box>
    </>
  );
}
export default UploadVendorInvoice;
